import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import { isMobileMedia } from 'utils/media';
import { generatePath } from 'utils/generatePath';
import { openModal } from 'base/actions/modal';

import { MENU } from 'menus/constants/entities';

import { CENTER } from 'base/constants/alignment';
import SelectedFulfillmentOptions from 'base/components/SelectedFulfillmentOptions';

/**
 * This component provides the Order for Pickup button which allows
 * the user to click it to change their fullfillment time. The
 * componentDidMount method also help check the current status of modals
 * and determine if any modal should be rendered.
 */
class ModifyFulfillmentTime extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    requested_fulfillment_is_asap: PropTypes.bool,
    fulfillment_date: PropTypes.string,
    fulfillment_time: PropTypes.string,
    restaurantName: PropTypes.string,
    currentPrepTime: PropTypes.number
  };

  changePickupTime = () => {
    this.renderOrderSettingComponent();
  };

  renderOrderSettingComponent = () => {
    const { history, match, dispatch } = this.props;
    const { slug } = match.params;

    if (!isMobileMedia()) {
      dispatch(openModal());
    }
    history.push(generatePath(MENU, 'orderSetting', { slug }));
  };

  render() {
    const {
      restaurantName,
      currentPrepTime,
      fulfillment_time,
      fulfillment_date,
      requested_fulfillment_is_asap
    } = this.props;
    return (
      <SelectedFulfillmentOptions
        restaurantName={restaurantName}
        currentPrepTime={currentPrepTime}
        fulfillmentTime={fulfillment_time}
        fulfillmentDate={fulfillment_date}
        requestedFulfillmentIsAsap={requested_fulfillment_is_asap}
        desktopAlign={CENTER}
        changePickupTime={this.changePickupTime}
        dataTestId="menu-page-pickup-time"
      />
    );
  }
}

export default withRouter(connect()(ModifyFulfillmentTime));
